import { useActiveAuthProvider } from '@refinedev/core';
import { useState, useEffect } from 'react';
import * as Sentry from '@sentry/react';

export const useGetUserCognitoGroup = () => {
  const [cognitoGroup, setCognitoGroup] = useState<string | null>(null);
  const authProvider = useActiveAuthProvider();

  useEffect(() => {
    if (!authProvider) return;

    const fetchPermissions = async () => {
      try {
        const role = await authProvider.getPermissions();
        if (role) {
          setCognitoGroup(role);
        }
      } catch (error) {
        Sentry.withScope((scope) => {
          scope.setTag('filename', 'useGetUserCognitoGroup.ts');
          Sentry.captureException(error);
        });
      }
    };

    fetchPermissions();
  }, [authProvider]);

  return cognitoGroup;
};
